import {TimeIntervalHelper} from "../time-interval-helper";

export class TimeIntervalBO {
  originalStartTime: Date; // Original start time
  originalEndTime: Date; // Original end time
  roundedStartTime: Date; // Time (floor) rounded to Quarter
  roundedEndTime: Date; // Time (ceil) rounded to Quarter
  intervalDuration: number; // 15 minutes in milliseconds
  intervalCount: number; // Number of intervals between start and end time
  constructor(originalStartTime: Date, originalEndTime: Date, intervalDuration: number) {
    this.originalStartTime = originalStartTime;
    this.originalEndTime = originalEndTime;
    this.intervalDuration = intervalDuration;

    this.roundedStartTime = TimeIntervalHelper.floorTimeToQuarter(originalStartTime, intervalDuration);
    this.roundedEndTime = TimeIntervalHelper.ceilTimeToQuarter(originalEndTime, intervalDuration);
    this.intervalCount = TimeIntervalHelper.calculateIntervalCount(this.roundedStartTime, this.roundedEndTime, intervalDuration);
  }
}
